<mat-drawer-container
  class="example-container relative bg-white-color"
  [hasBackdrop]="true"
>
  <mat-drawer-content class="relative">
    <div
      class="relative container mx-auto flex flex-col lg:flex-row h-full w-full"
      style="height: 100%"
    >
      <div
        class="w-full lg:w-[67%] xl:w-[80%] 2xl:lg:w-[85%] h-full pt-4 lg:pt-8"
      >
        <ng-container>
          <div class="flex items-start justify-between gap-2 md:mb-7 mb-5">
            <div class="flex items-center gap-2">
              <button mat-icon-button class="max-h-[24px]" (click)="goBack()">
                <mat-icon
                  class="mat-18 md:font-bold sm:font-semibold font-semibold text-orange-color"
                  >arrow_back</mat-icon
                >
              </button>

              <h4 class="text-base sm:text-lg md:text-xl font-semibold">
                {{ "Heavy Items & Relocation" }}
              </h4>
            </div>

            <div
              *ngIf="
                this.orderDoc && this.form.get('pickupLocationAddress').value
              "
              (click)="resetOrderFlow()"
              class="flex items-center text-orange-color gap-1 font-semibold text-base cursor-pointer"
            >
              <mat-icon
                matTooltip="Proceeding with this action will reset your current order data, and this action cannot be undone."
                class="mat-18 !text-xl"
                >info_outline</mat-icon
              >
              <div class="hover:underline">Reset Form</div>
            </div>
          </div>
        </ng-container>
        <form [formGroup]="this.form">
          <div
            class="flex flex-col md:gap-[50px] sm:gap-[45px] gap-[35px] w-full"
          >
            <div *ngIf="currentStep === 1">
              <div class="row mb-3">
                <h4
                  class="standard-heading mb-5 text-base sm:text-lg md:text-xl"
                >
                  {{ this.headings.relocate }} {{ this.headings.whatToPlan }}
                </h4>

                <div
                  class="text-[13px] sm:text-sm md:text-base text-dark-gray mb-3"
                >
                  {{ tipText }}
                </div>

                <label
                  class="form-label !text-blue-theme-color text-sm sm:text-base md:text-lg"
                >
                  {{ this.headings.pickupLocation | titlecase }}
                </label>
                <mat-form-field
                  class="cursor-pointer !max-w-[575px]"
                  appearance="fill"
                  (click)="onPickupLocation()"
                >
                  <input
                    readonly
                    matInput
                    formControlName="pickupLocationAddress"
                    class="cursor-pointer placeholder:text-[#000000DE]"
                    placeholder="Tap to enter exact pickup location"
                  />
                  <mat-icon
                    matSuffix
                    class="material-icons text-orange-color md:!mr-0 sm:!mr-[-10px] !mr-[-10px]"
                    >location_on</mat-icon
                  >
                  <mat-error
                    *ngIf="
                      this.form.get('pickupLocationAddress').value &&
                      this.form.get('pickupLocationAddress').touched
                    "
                    >Pickup Location
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">
                <label class="form-label text-sm sm:text-base md:text-lg">
                  {{ this.headings.dropOffLocation | titlecase }}
                </label>
                <ng-container
                  formArrayName="dropoffLocations"
                  *ngFor="
                    let dropoff of this.dropoffLocations['controls'];
                    let dropIndex = index
                  "
                >
                  <div class="w-full" [formGroup]="dropoff">
                    <mat-form-field
                      class="relative w-full !max-w-[575px]"
                      appearance="fill"
                      [ngClass]="{
                        'active-dropoff':
                          this.drawerContext.type == 'dropoff' &&
                          dropIndex === activeDropoffIndex,
                        'opacity-50 pointer-events-none': isOrderDocLoading
                      }"
                    >
                      <div class="flex flex-col w-full overflow-hidden">
                        <input
                          (click)="
                            !isOrderDocLoading &&
                              this.onDropOffLocation(
                                this.dropoffLocations['controls'],
                                dropIndex
                              )
                          "
                          readonly
                          formControlName="dropoffPointAddress"
                          class="cursor-pointer !pt-3 !pb-2 placeholder:text-[#000000DE] md:!pr-0 sm:!pr-3 !pr-3"
                          matInput
                          placeholder="Tap to enter exact drop-off location"
                        />
                      </div>
                      <mat-icon
                        *ngIf="
                          !dropIndex &&
                          !this.dropoff.get('dropoffPointAddress')?.value
                        "
                        matSuffix
                        class="material-icons text-orange-color md:!mr-0 sm:!mr-[-10px] !mr-[-10px]"
                        >location_on</mat-icon
                      >
                      <button
                        *ngIf="
                          !dropIndex
                            ? this.dropoff.get('dropoffPointAddress')?.value
                            : true
                        "
                        mat-icon-button
                        (click)="removeDropLocation(dropIndex)"
                        class="md:!mr-0 sm:!mr-[-10px] !mr-[-10px] md:!ml-0 sm:!ml-[6px] !ml-[6px]"
                        aria-label="Remove drop location"
                      >
                        <mat-icon class="material-icons text-orange-color"
                          >cancel</mat-icon
                        >
                      </button>
                    </mat-form-field>
                    <div
                      *ngIf="
                        dropIndex ==
                          this.dropoffLocations['controls'].length - 1 &&
                        this.dropoff.get('dropoffPointAddress').value &&
                        this.dropoffLocations['controls'].length < 3
                      "
                      (click)="this.addDropRow(dropIndex)"
                      class="flex items-center gap-1 cursor-pointer mb-[20px]"
                    >
                      <mat-icon
                        class="mat-14 bg-light-orange rounded-full text-white-color"
                        >add</mat-icon
                      >
                      <span class="!text-sm font-medium text-orange-color"
                        >Add more drop-off location</span
                      >
                    </div>
                  </div>
                </ng-container>
              </div>
              <button
                mat-flat-button
                color="primary"
                [disabled]="
                  !this.form.get('pickupLocationAddress').value ||
                  !this.dropoffLocations.controls[0]?.get('dropoffPointAddress')
                    ?.value
                "
                [ngClass]="{
                  'bg-blue-theme-color':
                    this.form.get('pickupLocationAddress').value &&
                    this.dropoffLocations.controls[0]?.get(
                      'dropoffPointAddress'
                    )?.value,
                  'bg-[#A1A1A1]':
                    !this.form.get('pickupLocationAddress').value ||
                    !this.dropoffLocations.controls[0]?.get(
                      'dropoffPointAddress'
                    )?.value
                }"
                class="gap-2 flex justify-center items-center !px-12 !h-14 rounded-md text-white-color"
                (click)="goToNextStep()"
              >
                Next
              </button>
            </div>

            <div *ngIf="currentStep === 2">
              <div id="packageSizeWrapper" class="row pb-3 mb-4">
                <h4
                  class="standard-heading sm:mb-4 mb-3 text-base sm:text-lg md:text-xl"
                >
                  Select Your Item Weight Category
                </h4>
                <div
                  class="grid 2xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                >
                  <ng-container
                    *ngFor="let package of this.packageSizes; let i = index"
                  >
                    <div
                      matRipple
                      (click)="onSelectPackage(i)"
                      [ngClass]="
                        package.isSelected
                          ? 'border-[#F54720] bg-[#FBF4F1]'
                          : 'border-slaty-color'
                      "
                      class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative cursor-pointer border-2 items-center bg-white rounded-lg flex flex-col justify-between"
                    >
                      <div class="flex-1 flex flex-col mr-auto">
                        <span
                          class="md:text-lg sm:text-base text-base text-blue-theme-color font-semibold"
                          >{{ package.name | titlecase }}</span
                        >
                        <span
                          class="text-[13px] text-[#7C8390] font-Inter-Medium font-medium"
                          >{{ package.info | titlecase }}</span
                        >
                      </div>
                      <img
                        draggable="false"
                        [src]="package.icon"
                        class="w-[50px] rounded-lg object-contain aspect-square ml-auto"
                        alt=""
                      />
                      <img
                        *ngIf="package.isSelected"
                        class="absolute w-5 aspect-square top-2 right-2"
                        src="assets/images/icons/checkMark.svg"
                        alt=""
                      />
                    </div>
                  </ng-container>
                </div>
                <span
                  *ngIf="this.selectedPackageSize"
                  class="text-sm sm:text-base md:text-lg mt-2 text-input-color"
                  >{{ this.selectedPackageSize?.desc }}</span
                >
              </div>

              <div>
                <h4
                  class="standard-heading mt-6 mb-2 sm:mb-4 text-base sm:text-lg md:text-xl"
                >
                  What Are We handling?
                </h4>
                <div class="row mb-[30px]">
                  <div
                    class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                  >
                    <ng-container
                      *ngFor="let item of this.handlingMethods; let i = index"
                    >
                      <div
                        matRipple
                        (click)="selectHandlingMethods(i)"
                        [ngClass]="
                          item.isSelected
                            ? 'border-orange-color bg-orange-color/5'
                            : 'border-gray-color '
                        "
                        class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative flex md:flex-row sm:justify-start sm:flex-row flex-col cursor-pointer border items-center rounded-lg sm:gap-3 gap-1"
                      >
                        <img
                          draggable="false"
                          [src]="item.icon"
                          class="w-[42px] aspect-square"
                          alt=""
                        />
                        <span
                          class="text-base text-blue-theme-color sm:text-left text-center font-semibold"
                          >{{ item.title | titlecase }}</span
                        >
                        <img
                          *ngIf="item.isSelected"
                          class="absolute w-5 aspect-square top-2 right-2"
                          src="assets/images/icons/checkMark.svg"
                          alt=""
                        />
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div *ngIf="this.handlingData.length" @showHide>
                  <h4 class="standard-heading !mb-4">Select Package Item</h4>
                  <div class="row mb-2">
                    <div
                      class="grid 2xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                    >
                      <ng-container
                        *ngFor="let item of this.handlingData; let i = index"
                      >
                        <div
                          (click)="onSelectPackagedItem(i)"
                          [ngClass]="
                            item.isSelected
                              ? 'border-orange-color bg-orange-color/5'
                              : 'border-light-gray bg-white-color'
                          "
                          matRipple
                          class="rounded-lg border relative cursor-pointer flex sm:flex-row flex-col items-center gap-2 px-4 md:py-4 sm:py-3 py-3"
                        >
                          <img
                            [src]="item.images"
                            onerror="this.onerror = null; this.src='assets/images/icons/other.png'"
                            draggable="false"
                            class="w-[33px] aspect-square"
                            alt=""
                          />
                          <span
                            class="text-blue-theme-color break-words sm:text-left sm:leading-5 leading-4 text-center text-sm font-medium sm:pr-0 pr-0"
                            >{{ item.title | titlecase }}</span
                          >
                          <img
                            *ngIf="item.isSelected"
                            class="absolute w-5 aspect-square top-2 right-2"
                            src="assets/images/icons/checkMark.svg"
                            alt=""
                          />
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <div
                    @showHide
                    *ngIf="
                      this.selectedHandling.id == 3 ||
                      this.selectedHandling.id == 4 ||
                      this.handlingItem?.id == 0
                    "
                    class="row md:w-[296px] lg:w-[580px] mt-8 w-full sm:w-full mb-2"
                  >
                    <label class="font-medium text-[14px]">Detail</label>
                    <mat-form-field appearance="fill" class="pr-0">
                      <input
                        formControlName="attachmentInfo"
                        matInput
                        placeholder="3 boxes of plumbing fixtures, etc."
                      />
                      <button
                        mat-icon-button
                        *ngIf="
                          !this.form.get('attachment').dirty &&
                          !this.attachmentUploadedUrl
                        "
                        (click)="itemAttachment.click()"
                        matTooltip="Attach Image"
                        matRipple
                        class="w-[40px] aspect-square flex items-center justify-center rounded-full"
                      >
                        <mat-icon class="mat-18 text-[#F54720]"
                          >attach_file</mat-icon
                        >
                      </button>
                      <mat-progress-spinner
                        *ngIf="this.form.get('attachment').dirty"
                        class="imageUpload pr-6"
                        [diameter]="24"
                        [mode]="'indeterminate'"
                      ></mat-progress-spinner>
                      <input
                        type="file"
                        class="invisible w-0 h-0"
                        (change)="onAttachmentSelect($event)"
                        formControlName="attachment"
                        #itemAttachment
                        accept="image/png, image/gif, image/jpeg"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    @showHide
                    *ngIf="
                      ((this.selectedHandling.id == 3 ||
                        this.selectedHandling.id == 4) &&
                        this.attachmentUploadedUrl &&
                        isAttachmentUploaded) ||
                      (this.handlingItem?.id == 0 &&
                        this.attachmentUploadedUrl &&
                        isAttachmentUploaded)
                    "
                  >
                    <div class="w-52 aspect-video relative">
                      <img
                        [src]="this.attachmentUploadedUrl"
                        class="w-full h-full object-cover"
                        alt=""
                      />
                      <button
                        (click)="onRemoveAttachment()"
                        mat-icon-button
                        matRipple
                        class="absolute w-[40px] aspect-square flex items-center justify-center rounded-full top-0 right-0"
                      >
                        <mat-icon class="mat-18 text-orange-color"
                          >close</mat-icon
                        >
                      </button>
                    </div>
                  </div>

                  <div
                    *ngIf="
                      this.selectedHandling.id == 3 ||
                      this.selectedHandling.id == 4
                    "
                    @showHide
                  >
                    <div class="mb-[30px] flex items-start gap-[4px]">
                      <mat-slide-toggle
                        formControlName="isLoadingFeeApplied"
                        class="mb-3"
                      ></mat-slide-toggle>
                      <div>
                        <p
                          class="sm:text-lg text-base text-blue-theme-color font-medium"
                        >
                          Do you want a loader?
                        </p>
                        <p class="text-sm text-blue-theme-color">
                          Add professional loading/unloading assistance.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  @showHide
                  *ngIf="
                    this.form.get('pickupLocationAddress')?.value &&
                    this.dropoffLocations.controls[
                      this.dropoffLocations?.controls?.length - 1
                    ]?.get('dropoffPointAddress')?.value &&
                    this.handlingItem
                  "
                >
                  <h4
                    class="standard-heading text-lg sm:text-xl md:text-[20px] mb-4"
                  >
                    Select Delivery Method
                  </h4>
                  <div class="row mb-2">
                    <div
                      class="grid 2xl:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-2 md:gap-5 sm:gap-3 gap-2"
                    >
                      <ng-container
                        *ngFor="
                          let item of this.filteredDeliveryMethods;
                          let i = index
                        "
                      >
                        <div
                          matRipple
                          (click)="
                            item?.notSelectable
                              ? null
                              : onSelectdeliveryMethods(i)
                          "
                          [ngClass]="[
                            item?.isSelected
                              ? 'border-orange-color bg-orange-color/5'
                              : 'border-gray-color   bg-slaty-color',
                            i === this.filteredDeliveryMethods.length - 1 &&
                            this.filteredDeliveryMethods.length % 2 !== 0
                              ? 'col-span-2 md:col-span-1'
                              : ''
                          ]"
                          class="delivery-method-card relative flex flex-col justify-between border rounded-xl p-2 md:p-4 min-h-[180px] w-full cursor-pointer transition-all"
                        >
                          <div class="flex justify-between items-start">
                            <div
                              class="font-bold text-[14px] sm:text-lg text-blue-theme-color mb-1"
                            >
                              {{ item.type || "N/A" }}
                            </div>
                            <div
                              class="absolute top-[56px] sm:top-[48px] lg:top-[26px] 2xl:top-[26px] right-[10px] md:right-3 flex flex-col items-end gap-1 z-10"
                            >
                              <ng-container *ngIf="item.isRecommended">
                                <span class="tag tag-recommended text-nowrap"
                                  >Recommended</span
                                >
                              </ng-container>
                              <ng-container *ngIf="item?.notSelectable">
                                <span
                                  [ngClass]="
                                    item.type.includes('PickUp')
                                      ? 'tag tag-not-available text-nowrap mt-4'
                                      : 'tag tag-not-available text-nowrap'
                                  "
                                  >Not available
                                </span>
                              </ng-container>
                              <ng-container *ngIf="item.label == 'Saver'">
                                <span class="tag tag-saver text-nowrap">
                                  Saver
                                </span>
                              </ng-container>
                              <img
                                *ngIf="item.isSelected"
                                class="w-6 h-6"
                                src="assets/images/icons/checkMark.svg"
                                alt="Selected"
                              />
                            </div>
                          </div>

                          <div class="flex items-center gap-2 mb-1">
                            <span
                              class="text-orange-color font-bold text-[12px] sm:text-sm"
                            >
                              {{ item.currency || "" }}
                              {{ item.grossTotal || 0 }}
                            </span>
                            <span
                              *ngIf="item.totalCharges > item.grossTotal"
                              class="text-dark-gray text-[13px] sm:text-base line-through"
                            >
                              {{ item.currency || "" }}
                              {{ item.totalCharges || 0 }}
                            </span>
                          </div>

                          <div
                            class="text-blue-500 text-[12px] sm:text-sm font-semibold mb-2"
                          >
                            {{ item.estimateTime || "" }}
                          </div>

                          <div class="flex justify-end items-end flex-1">
                            <img
                              [src]="item.icon"
                              class="w-[60px] sm:w-24 sm:h-16 object-contain"
                              alt="{{ item.type }}"
                              style="max-width: 100px; max-height: 70px"
                            />
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="min-h-6">
                    <ng-container *ngIf="this.selectedDeliveryMethod?.id">
                      <span
                        @showHide
                        class="text-sm sm:text-base md:text-lg mt-2 text-input-color"
                      >
                        {{
                          this.selectedDeliveryMethod?.id === 2
                            ? "Perfect for small to lightweight items, up to 30 kg."
                            : this.selectedDeliveryMethod?.id === 3
                            ? "Ideal for medium to moderately heavy items, ranging from 40 kg to 95 kg."
                            : this.selectedDeliveryMethod?.id === 1
                            ? "Best suited for ultra-lightweight items, up to 10 kg"
                            : this.isSeverPlan &&
                              this.selectedDeliveryMethod?.id == 7
                            ? "Perfect for small to lightweight items, up to 30 kg."
                            : ""
                        }}
                      </span>
                    </ng-container>
                  </div>
                </div>
                <div
                  @showHide
                  *ngIf="this.selectedDeliveryMethod?.id !== 7"
                  class="mb-[30px]"
                >
                  <h4 class="standard-heading mt-4 !mb-3">Schedule Delivery</h4>
                  <mat-slide-toggle formControlName="isScheduleDelivery"
                    ><span
                      class="sm:text-lg text-base text-blue-theme-color font-semibold"
                      >Schedule This Delivery
                    </span></mat-slide-toggle
                  >
                  <div
                    @showHide
                    *ngIf="this.form.get('isScheduleDelivery')?.value"
                    class="row md:w-[296px] w-full sm:w-full mt-4"
                  >
                    <mat-form-field appearance="fill">
                      <input
                        formControlName="scheduleDelivery"
                        [min]="this.currentTime"
                        matInput
                        readonly
                        (click)="$event.stopPropagation(); tSaleEndDate.open()"
                        [ngxMatDatetimePicker]="tSaleEndDate"
                      />
                      <button
                        mat-icon-button
                        matRipple
                        (click)="$event.stopPropagation(); tSaleEndDate.open()"
                      >
                        <img
                          matIconSuffix
                          class="w-6 aspect-square"
                          src="assets/images/icons/dateTimePicker.png"
                        />
                      </button>
                      <ngx-mat-datetime-picker
                        #tSaleEndDate
                        [showSpinners]="true"
                        [showSeconds]="false"
                        [enableMeridian]="true"
                      >
                      </ngx-mat-datetime-picker>
                    </mat-form-field>
                  </div>
                </div>

                <ng-container
                  *ngIf="
                    (this.isPharmacyOrder &&
                      this.orderDoc?.paymentMethod?.length) ||
                    !this.isPharmacyOrder
                  "
                >
                  <div class="mb-[30px]">
                    <h4
                      class="standard-heading mt-4 !mb-3 text-base sm:text-lg md:text-xl"
                    >
                      Payment Method
                    </h4>
                    <div class="mb-2">
                      <div
                        class="lg:flex grid grid-cols-1 md:gap-5 sm:gap-3 gap-2"
                      >
                        <ng-container
                          *ngFor="
                            let item of this.paymentMethods;
                            let i = index
                          "
                        >
                          <div
                            matRipple
                            (click)="onSelectPaymentMethod(item, i)"
                            [ngClass]="[
                              item?.isSelected
                                ? 'border-orange-color bg-orange-color/5'
                                : 'border-gray-color   bg-slaty-color'
                            ]"
                            class="py-5 px-4 relative flex-1 flex cursor-pointer border items-center rounded-lg gap-3"
                          >
                            <div
                              *ngIf="
                                i == 2
                                  ? item.addIsRecommended &&
                                    this.selectedDeliveryMethod
                                    ? this.selectedDeliveryMethod
                                        ?.pdasWalletAmount < 0
                                    : true
                                  : item.isRecommended
                              "
                              class="absolute font-light bottom-0 z-10 right-1 tag tag-recommended !rounded-b-none text-white-color !mb-0 !text-[10px] px-2 !py-[0px]"
                            >
                              Recommended
                            </div>

                            <img
                              draggable="false"
                              [src]="
                                item.isSelected ? item.selectedIcon : item.icon
                              "
                              class="w-[40px] aspect-square"
                              alt=""
                            />
                            <div class="flex-1">
                              <span
                                class="sm:text-base text-base text-blue-theme-color font-semibold"
                                >{{ item.title | titlecase }}</span
                              >
                              <div
                                class="flex justify-between"
                                *ngIf="item.id == 3"
                              >
                                <p class="text-sm font-bold text-orange-color">
                                  {{ this.selectedDeliveryMethod?.currency }}
                                  {{
                                    this.selectedDeliveryMethod
                                      ?.pdasWalletAmount
                                  }}
                                </p>
                              </div>
                            </div>
                            <img
                              *ngIf="item.isSelected"
                              class="absolute w-5 aspect-square top-2 right-2"
                              src="assets/images/icons/checkMark.svg"
                              alt=""
                            />
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="
                      this.paymentMethods[0].id == 1 &&
                      this.paymentMethods[0].isSelected
                    "
                    @showHide
                  >
                    <h4 class="standard-heading mb-3">Cash on Service</h4>
                    <div class="row mb-2">
                      <div
                        class="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 md:gap-5 sm:gap-3 gap-2"
                      >
                        <ng-container
                          *ngFor="let item of this.cashSerive; let i = index"
                        >
                          <div
                            matRipple
                            (click)="onSelectCashSerive(i)"
                            [ngClass]="
                              item.isSelected
                                ? 'border-[#F54720] bg-[#FBF4F1]'
                                : 'border-[#D8DFE7] bg-transparent'
                            "
                            class="md:px-3 md:py-[14px] sm:px-3 sm:py-2 px-3 py-2 relative flex cursor-pointer border items-center rounded-lg gap-3"
                          >
                            <img
                              draggable="false"
                              [src]="
                                item.isSelected ? item.selectedIcon : item.icon
                              "
                              class="w-[40px] aspect-square"
                              alt=""
                            />
                            <div class="flex-1">
                              <span
                                class="sm:text-base text-base text-blue-theme-color font-semibold"
                                >{{ item.title | titlecase }}</span
                              >
                              <div class="flex justify-between">
                                <p
                                  class="md:text-lg sm:text-base text-base font-bold text-orange-color"
                                >
                                  {{ item?.curency }} {{ item?.amount }}
                                </p>
                              </div>
                            </div>
                            <img
                              *ngIf="item.isSelected"
                              class="absolute w-5 aspect-square top-2 right-2"
                              src="assets/images/icons/checkMark.svg"
                              alt=""
                            />
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div *ngIf="this.selectedPaymentMethod" class="pt-4">
                  <mat-slide-toggle
                    formControlName="isPromoApplied"
                    class="mb-3"
                    (change)="
                      this.form.get('isPromoApplied').value
                        ? this.openPromoCodeDialog()
                        : this.removePromoCode()
                    "
                    ><span
                      class="sm:text-lg text-base text-blue-theme-color font-semibold"
                      >Apply Promo Code</span
                    ></mat-slide-toggle
                  >
                  <div class="row md:w-[296px] w-full sm:w-full mb-2">
                    <mat-form-field
                      *ngIf="this.form.get('isPromoApplied').value"
                      appearance="fill"
                    >
                      <input
                        [readonly]="true"
                        matInput
                        formControlName="promoTitle"
                        class="uppercase"
                      />
                      <button
                        *ngIf="this.form.get('promoTitle').value"
                        (click)="this.removePromoCode()"
                        mat-icon-button
                      >
                        <mat-icon class="material-icons text-orange-color"
                          >cancel</mat-icon
                        >
                      </button>
                      <mat-error
                        *ngIf="this.form.get('promoTitle').hasError('inValid')"
                        >Invaild promo code.</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="this.selectedPaymentMethod" class="pb-5">
                  <mat-slide-toggle formControlName="useTip"
                    ><span
                      class="sm:text-lg text-base text-blue-theme-color font-semibold"
                      >Leave a TIP for driver?</span
                    ></mat-slide-toggle
                  >
                </div>
                <div
                  class="flex md:flex-row sm:flex-col flex-col md:gap-6 sm:gap-0 gap-0"
                >
                  <div
                    *ngIf="
                      this.form.get('useTip').value &&
                      this.selectedPaymentMethod
                    "
                    class="row md:w-[296px] w-full sm:w-full"
                  >
                    <mat-form-field appearance="fill">
                      <input
                        type="number"
                        min="1"
                        step="any"
                        (blur)="onChangeTipAmount()"
                        (keydown)="preventInvalidKeys($event)"
                        formControlName="tipAmount"
                        matInput
                        placeholder="Enter tip amount"
                        class="uppercase placeholder:text-[#000000DE]"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="pb-[25px]">
                <button
                  mat-flat-button
                  color="primary"
                  class="bg-blue-theme-color gap-2 flex justify-center items-center !px-12 !h-14 text-white-color rounded-md"
                  (click)="goToPreviousStep()"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </form>
        <aside class="lg:hidden block" *ngIf="shouldShowPaymentSummary">
          <div class="pt-6 summary-content">
            <div class="overflow-y-auto px-4">
              <ng-container
                *ngTemplateOutlet="paymentSummaryTemplate"
              ></ng-container>
            </div>

            <div
              class="w-full my-4 px-4"
              *ngIf="
                this.selectedDeliveryMethod &&
                this.selectedDeliveryMethod.walletAmt > 0 &&
                !this.isPharmacyOrder
              "
            >
              <mat-slide-toggle
                [formControl]="form.get('isPhlenuCashApplied')"
                (change)="onPhlenuCashToggle($event)"
                class="w-full flex items-center justify-between"
              >
                <span
                  class="text-blue-theme-color font-semibold !text-sm sm:!text-base"
                >
                  Apply Phlenu Cash ({{
                    this.selectedDeliveryMethod?.currency
                  }}
                  {{ this.selectedDeliveryMethod?.walletAmt || 0 }})
                </span>
              </mat-slide-toggle>
            </div>

            <div
              *ngIf="this.selectedDeliveryMethod?.cashBack"
              class="mb-3 px-2 py-2 flex gap-2 border border-[#D8DFE7] rounded-xl mt-4 items-center mx-2"
            >
              <img
                class="w-8 aspect-square"
                src="assets/images/ui/cashback_gif.gif"
                alt=""
              />
              <span class="text-xs text-blue-theme-color leading-4">
                Fantastic! This order will credit
                <strong
                  >{{ this.selectedDeliveryMethod?.cashBack || 0 }}
                  {{ this.selectedDeliveryMethod?.currency }}</strong
                >
                Phlenu cash back rewards to your account.
              </span>
            </div>

            <div class="px-4 my-8">
              <button
                mat-flat-button
                color="primary"
                class="w-full text-white-color rounded-lg bg-blue-theme-color !h-12"
                [disabled]="this.isConfirmingOrder"
                (click)="onConfirm()"
              >
                <span *ngIf="!this.isConfirmingOrder">Confirm Order</span>
                <mat-progress-spinner
                  class="custom-spinner text-white-color mx-auto"
                  *ngIf="this.isConfirmingOrder"
                  [diameter]="24"
                  [mode]="'indeterminate'"
                ></mat-progress-spinner>
              </button>
            </div>
          </div>
        </aside>
      </div>

      <aside *ngIf="shouldShowPaymentSummary" class="summary-aside">
        <div class="pt-6 summary-content">
          <div class="overflow-y-auto px-4">
            <ng-container
              *ngTemplateOutlet="paymentSummaryTemplate"
            ></ng-container>
          </div>

          <div
            class="w-full my-4 px-4"
            *ngIf="
              this.selectedDeliveryMethod &&
              this.selectedDeliveryMethod.walletAmt > 0 &&
              !this.isPharmacyOrder
            "
          >
            <mat-slide-toggle
              [formControl]="form.get('isPhlenuCashApplied')"
              (change)="onPhlenuCashToggle($event)"
              class="w-full flex items-center justify-between"
            >
              <span
                class="text-blue-theme-color font-semibold !text-sm sm:!text-base"
              >
                Apply Phlenu Cash ({{ this.selectedDeliveryMethod?.currency }}
                {{ this.selectedDeliveryMethod?.walletAmt || 0 }})
              </span>
            </mat-slide-toggle>
          </div>

          <div
            *ngIf="this.selectedDeliveryMethod?.cashBack"
            class="mb-3 px-2 py-2 flex gap-2 border border-[#D8DFE7] rounded-xl mt-4 items-center mx-2"
          >
            <img
              class="w-8 aspect-square"
              src="assets/images/ui/cashback_gif.gif"
              alt=""
            />
            <span class="text-xs text-blue-theme-color leading-4">
              Fantastic! This order will credit
              <strong
                >{{ this.selectedDeliveryMethod?.cashBack || 0 }}
                {{ this.selectedDeliveryMethod?.currency }}</strong
              >
              Phlenu cash back rewards to your account.
            </span>
          </div>

          <div class="px-4 my-8">
            <button
              mat-flat-button
              color="primary"
              class="w-full text-white-color rounded-lg bg-blue-theme-color !h-12"
              [disabled]="this.isConfirmingOrder"
              (click)="onConfirm()"
            >
              <span *ngIf="!this.isConfirmingOrder">Confirm Order</span>
              <mat-progress-spinner
                class="custom-spinner text-white-color mx-auto"
                *ngIf="this.isConfirmingOrder"
                [diameter]="24"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
            </button>
          </div>
        </div>
      </aside>
    </div>
  </mat-drawer-content>

  <mat-drawer
    #pickupDrawer
    mode="over"
    class="w-[350px] !fixed !top-[70px]"
    position="end"
  >
    <app-pickup-locations-dialog
      *ngIf="isPickupDrawerOpen"
      [heading]="
        drawerContext.type === 'pickup'
          ? 'Recent Pickup Locations'
          : 'Recent Dropoff Locations'
      "
      [isPickup]="drawerContext.type === 'pickup' ? 1 : 0"
      [selected]="
        drawerContext.type === 'pickup'
          ? form.get('pickupLocation').value
          : getAllDropoffLocations()
      "
      [isHeavyItemAndRelocateOrder]="isHeavyItemAndRelocateOrder"
      [groupIndex]="drawerContext.dropoffIndex"
      [isShowTrustCheck]="this.orderDoc?.isPhlenutrustCheckEnabled"
      (close)="onPickupDrawerClose()"
      (locationSelected)="onPickupLocationSelected($event)"
    ></app-pickup-locations-dialog>
  </mat-drawer>

  <!-- Payment Summary Template -->
  <ng-template #paymentSummaryTemplate>
    <ul class="">
      <li class="flex w-full py-2">
        <div class="flex flex-col w-full">
          <span
            class="bill-label text-sm sm:text-base md:text-lg text-blue-theme-color font-semibold mb-[15px]"
            >Payment Summary</span
          >

          <div
            class="flex flex-col w-full shadow-sm border border-[#D8DFE7] rounded-lg"
          >
            <ng-container
              *ngFor="let dropoff of dropPointsToShow; let dropIndex = index"
            >
              <!-- Route Card Design -->
              <div class="route-card bg-white p-4">
                <!-- Header with title and numbers -->
                <div class="flex justify-between items-start mb-3 pb-4">
                  <div class="flex items-center gap-2">
                    <span
                      class="text-sm sm:text-base text-black-color font-semibold capitalize"
                    >
                      <!-- Shimmer for dropoff name -->
                      <div
                        *ngIf="shouldShowPaymentSummaryShimmer()"
                        class="h-4 bg-gray-color rounded animate-pulse w-24"
                      ></div>
                      <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                        {{ dropoff?.name || "Drop-off " + (dropIndex + 1) }}
                        <span
                          *ngIf="dropoff?.isPhlenuTrustCheckApplied"
                          class="inline-flex items-center bg-[#ddf5db] text-green-color text-[10px] font-medium ml-1 px-2 rounded-full"
                        >
                          🛡️ Verified
                        </span>
                      </span>
                    </span>
                  </div>
                  <div class="flex gap-2">
                    <s
                      *ngIf="!this.isBusinessPartner"
                      class="text-sm font-bold text-gray-700"
                      >{{ dropoff?.charges || 0 }}</s
                    >
                    <span class="text-sm font-bold text-blue-theme-color">{{
                      dropoff?.payToCustomer || 0
                    }}</span>
                  </div>
                </div>

                <!-- Route Line with Pickup and Delivery -->
                <div class="route-line-container pt-4 relative">
                  <!-- Horizontal route line -->
                  <div
                    class="route-line w-full h-0.5 bg-gray-300 relative"
                  ></div>

                  <!-- Pickup Location (Left) -->
                  <div
                    class="pickup-location absolute left-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                  >
                    <mat-icon
                      class="text-white-color rounded-full bg-orange-color text-sm"
                      >location_on</mat-icon
                    >
                    <span class="text-xs text-gray-600 font-medium mt-1"
                      >Pickup</span
                    >
                  </div>

                  <!-- Distance in center -->
                  <div
                    class="distance-indicator absolute left-1/2 top-[-10px] transform -translate-x-1/2 -translate-y-1/2 bg-[#E3F2FD] px-2"
                  >
                    <span class="text-xs text-[#387DF4] font-semibold">
                      {{ dropoff?.distance || 0 }} KM
                    </span>
                  </div>

                  <!-- Delivery Location (Right) -->
                  <div
                    class="delivery-location absolute right-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                  >
                    <mat-icon
                      class="text-white-color rounded-full bg-blue-theme-color text-sm"
                      >location_on</mat-icon
                    >
                    <span class="text-xs text-gray-600 font-medium mt-1"
                      >Delivery</span
                    >
                  </div>
                </div>

                <!-- Address below route -->
                <div class="mt-3">
                  <span
                    *ngIf="dropoff?.address"
                    class="text-xs text-gray-500 line-clamp-2"
                  >
                    <!-- Shimmer for address -->
                    <div
                      *ngIf="shouldShowPaymentSummaryShimmer()"
                      class="h-3 bg-gray-color rounded animate-pulse w-32"
                    ></div>
                    <span *ngIf="!shouldShowPaymentSummaryShimmer()">
                      {{ dropoff?.address }}
                    </span>
                  </span>
                </div>
              </div>

              <span
                class="px-2"
                *ngIf="dropIndex !== dropPointsToShow.length - 1"
                ><mat-divider> </mat-divider
              ></span>
            </ng-container>

            <!-- Empty state shimmer when no dropoff points -->
            <div
              *ngIf="
                shouldShowPaymentSummaryShimmer() &&
                (!this.selectedDeliveryMethod?.dropPoint ||
                  this.selectedDeliveryMethod?.dropPoint.length === 0)
              "
              class="route-card bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
            >
              <div class="flex justify-between items-start mb-3">
                <div class="flex items-center gap-2">
                  <div
                    class="h-4 bg-gray-color rounded animate-pulse w-24"
                  ></div>
                  <div
                    class="h-6 bg-gray-color rounded-full animate-pulse w-16"
                  ></div>
                </div>
                <div class="flex gap-2">
                  <div
                    class="h-4 bg-gray-color rounded animate-pulse w-8"
                  ></div>
                  <div
                    class="h-4 bg-gray-color rounded animate-pulse w-8"
                  ></div>
                </div>
              </div>
              <div class="route-line-container relative">
                <div class="route-line w-full h-0.5 bg-gray-300 relative"></div>
                <div
                  class="absolute left-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                >
                  <div
                    class="h-6 w-6 bg-gray-color rounded animate-pulse"
                  ></div>
                  <div
                    class="h-3 bg-gray-color rounded animate-pulse w-12 mt-1"
                  ></div>
                </div>
                <div
                  class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white px-2"
                >
                  <div
                    class="h-3 bg-gray-color rounded animate-pulse w-12"
                  ></div>
                </div>
                <div
                  class="absolute right-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center"
                >
                  <div
                    class="h-6 w-6 bg-gray-color rounded animate-pulse"
                  ></div>
                  <div
                    class="h-3 bg-gray-color rounded animate-pulse w-16 mt-1"
                  ></div>
                </div>
              </div>
              <div class="mt-3">
                <div class="h-3 bg-gray-color rounded animate-pulse w-32"></div>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- <mat-divider> </mat-divider> -->
      <div class="flex flex-col gap-[8px] py-[4px]">
        <li class="flex justify-between">
          <span class="bill-label !text-[14px] text-black-color">{{
            !this.isBusinessPartner ? "Total Before Discount" : "Total"
          }}</span>
          <span
            class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="
                shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.totalCharges
                )
              "
              class="data-spinner text-blue-theme-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span
              *ngIf="
                !shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.totalCharges
                )
              "
            >
              {{ getAmountDisplay(this.selectedDeliveryMethod?.totalCharges) }}
            </span>
          </span>
        </li>
        <li
          *ngIf="
            this.selectedDeliveryMethod?.promoResponse?.promoDiscountAmount > 0
          "
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color"
            >(-) Promotion</span
          >
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="
                shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.promoResponse
                    ?.promoDiscountAmount
                )
              "
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span
              *ngIf="
                !shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.promoResponse
                    ?.promoDiscountAmount
                )
              "
            >
              {{
                getAmountDisplay(
                  this.selectedDeliveryMethod?.promoResponse
                    ?.promoDiscountAmount
                )
              }}
            </span>
          </span>
        </li>
        <li
          *ngIf="this.selectedDeliveryMethod?.discountAmount > 0"
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color">
            (-)Discount ({{
              this.selectedDeliveryMethod?.discountinpercentage || 0
            }}%)
          </span>
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="
                shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.discountAmount
                )
              "
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span
              *ngIf="
                !shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.discountAmount
                )
              "
            >
              {{
                getAmountDisplay(this.selectedDeliveryMethod?.discountAmount)
              }}
            </span>
          </span>
        </li>

        <li
          *ngIf="this.orderDoc?.isPhlenuCashApplied"
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color"
            >(-) Phlenu Cash</span
          >
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="
                shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.phlenuCashAmount
                )
              "
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span
              *ngIf="
                !shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.phlenuCashAmount
                )
              "
            >
              {{
                getAmountDisplay(this.selectedDeliveryMethod?.phlenuCashAmount)
              }}
            </span>
          </span>
        </li>
        <li
          *ngIf="this.orderDoc?.isPdasWalletApplied"
          class="flex justify-between"
        >
          <span class="bill-label !text-sm text-black-color"
            >(-) Wallet Used</span
          >
          <span
            class="bill-value text-green-color font-semibold !text-sm sm:!text-base"
          >
            <mat-progress-spinner
              *ngIf="
                shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.pdasWalletUsedAmount
                )
              "
              class="data-spinner text-green-color"
              [diameter]="20"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
            <span
              *ngIf="
                !shouldShowPaymentSummaryShimmer(
                  this.selectedDeliveryMethod?.pdasWalletUsedAmount
                )
              "
            >
              {{
                getAmountDisplay(
                  this.selectedDeliveryMethod?.pdasWalletUsedAmount
                )
              }}
            </span>
          </span>
        </li>
      </div>
    </ul>

    <mat-divider></mat-divider>
    <div class="flex flex-col gap-[8px] py-[4px]">
      <div
        *ngIf="
          this.selectedDeliveryMethod?.grossTotal > 0 && !this.isBusinessPartner
        "
        class="flex justify-between"
      >
        <span class="bill-label !text-sm text-black-color"
          >Discounted Amount</span
        >
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >
          <mat-progress-spinner
            *ngIf="
              shouldShowPaymentSummaryShimmer(
                this.selectedDeliveryMethod?.grossTotal
              )
            "
            class="data-spinner text-blue-theme-color"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <span
            *ngIf="
              !shouldShowPaymentSummaryShimmer(
                this.selectedDeliveryMethod?.grossTotal
              )
            "
          >
            {{ getAmountDisplay(this.selectedDeliveryMethod?.grossTotal) }}
          </span>
        </span>
      </div>
      <div *ngIf="this.orderDoc?.isTipGiven" class="flex justify-between">
        <span class="bill-label !text-sm text-black-color">
          (+) Driver Tip</span
        >
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >
          <mat-progress-spinner
            *ngIf="shouldShowPaymentSummaryShimmer(this.orderDoc?.tipAmount)"
            class="data-spinner text-blue-theme-color"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <span
            *ngIf="!shouldShowPaymentSummaryShimmer(this.orderDoc?.tipAmount)"
          >
            {{ getAmountDisplay(this.orderDoc?.tipAmount) }}
          </span>
        </span>
      </div>
      <div
        class="flex justify-between items-center"
        *ngIf="getIsTrustCheckApplied()"
      >
        <div class="flex items-center gap-1">
          <span class="text-[14px] text-black-color">Phlenu TrustCheck</span>

          <mat-icon
            matTooltipClass="custom-tooltip"
            [matTooltip]="trustCheckTooltip"
            matTooltipPosition="above"
            class="text-dark-gray cursor-pointer text-[12px]"
            >info_outline</mat-icon
          >
        </div>

        <span class="text-[16px] text-blue-theme-color font-semibold">
          <mat-progress-spinner
            *ngIf="
              shouldShowPaymentSummaryShimmer(
                this.orderDoc?.deliveryCharges[0]
                  ?.totalPhlenuTrustCheckCommisionApplied
              )
            "
            class="data-spinner text-blue-theme-color"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <span
            *ngIf="
              !shouldShowPaymentSummaryShimmer(
                this.orderDoc?.deliveryCharges[0]
                  ?.totalPhlenuTrustCheckCommisionApplied
              )
            "
          >
            {{
              getAmountDisplay(
                this.orderDoc?.deliveryCharges[0]
                  ?.totalPhlenuTrustCheckCommisionApplied
              )
            }}
          </span>
        </span>
      </div>
    </div>
    <mat-divider
      *ngIf="
        this.orderDoc?.isTipGiven ||
        (this.selectedDeliveryMethod?.grossTotal > 0 && !this.isBusinessPartner)
      "
    ></mat-divider>
    <div class="flex justify-between py-2">
      <span
        class="bill-label !text-sm sm:!text-lg text-orange-color font-semibold"
        >Delivery Charge</span
      >
      <span
        class="bill-value !text-sm sm:!text-lg text-orange-color font-medium"
      >
        {{ this.selectedDeliveryMethod?.currency }}
        <mat-progress-spinner
          *ngIf="
            shouldShowPaymentSummaryShimmer(
              this.selectedDeliveryMethod?.netTotal
            )
          "
          class="data-spinner text-orange-color"
          [diameter]="20"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
        <span
          *ngIf="
            !shouldShowPaymentSummaryShimmer(
              this.selectedDeliveryMethod?.netTotal
            )
          "
        >
          {{ getAmountDisplay(this.selectedDeliveryMethod?.netTotal) }}
        </span>
      </span>
    </div>

    <mat-divider></mat-divider>

    <li
      *ngIf="this.selectedDeliveryMethod?.loadingFee > 0"
      class="flex pt-2 justify-between"
    >
      <span class="bill-label !text-sm text-black-color"> Loading Fee</span>
      <span
        class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
      >
        <mat-progress-spinner
          *ngIf="
            shouldShowPaymentSummaryShimmer(
              this.selectedDeliveryMethod?.loadingFee
            )
          "
          class="data-spinner text-blue-theme-color"
          [diameter]="20"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
        <span
          *ngIf="
            !shouldShowPaymentSummaryShimmer(
              this.selectedDeliveryMethod?.loadingFee
            )
          "
        >
          {{ getAmountDisplay(this.selectedDeliveryMethod?.loadingFee) }}
        </span>
      </span>
    </li>

    <div
      class="flex flex-col pt-2"
      *ngIf="this.isTotalCashCollection() && this.selectedDeliveryMethod"
    >
      <li class="flex justify-between">
        <span class="bill-label !text-[14px] text-black-color"
          >Cash collection</span
        >
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >
          <mat-progress-spinner
            class="data-spinner text-blue-theme-color"
            *ngIf="isDataLoading; else dataVisible"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <ng-template #dataVisible>
            <span
              class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
              >{{ this.selectedDeliveryMethod?.currency }}
              <mat-progress-spinner
                *ngIf="
                  shouldShowPaymentSummaryShimmer(this.getTotalCashCollection())
                "
                class="data-spinner text-blue-theme-color"
                [diameter]="20"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
              <span
                *ngIf="
                  !shouldShowPaymentSummaryShimmer(
                    this.getTotalCashCollection()
                  )
                "
              >
                {{ getAmountDisplay(this.getTotalCashCollection()) }}
              </span></span
            >
          </ng-template>
        </span>
      </li>

      <li class="flex justify-between">
        <span class="bill-label !text-[14px] text-black-color"
          >Cash collection Fee
        </span>
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >
          <mat-progress-spinner
            class="data-spinner text-blue-theme-color"
            *ngIf="isDataLoading; else collectiondataVisible"
            [diameter]="20"
            [mode]="'indeterminate'"
          ></mat-progress-spinner>
          <ng-template #collectiondataVisible>
            <span
              class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
              >{{ this.selectedDeliveryMethod?.currency }}
              <mat-progress-spinner
                *ngIf="
                  shouldShowPaymentSummaryShimmer(
                    this.selectedDeliveryMethod?.feeOnCashCollect
                  )
                "
                class="data-spinner text-blue-theme-color"
                [diameter]="20"
                [mode]="'indeterminate'"
              ></mat-progress-spinner>
              <span
                *ngIf="
                  !shouldShowPaymentSummaryShimmer(
                    this.selectedDeliveryMethod?.feeOnCashCollect
                  )
                "
              >
                {{
                  getAmountDisplay(
                    this.selectedDeliveryMethod?.feeOnCashCollect
                  )
                }}
              </span></span
            >
          </ng-template>
        </span>
      </li>
    </div>

    <!-- Estimated time -->
    <div
      *ngIf="this.selectedDeliveryMethod?.estimateTime && !this.isPharmacyOrder"
      class="flex justify-between pt-2"
    >
      <span
        class="bill-label !text-blue-theme-color font-semibold !text-sm sm:!text-base"
        >Estimated time</span
      >
      <mat-progress-spinner
        class="data-spinner text-blue-theme-color"
        *ngIf="isDataLoading; else dataVisible"
        [diameter]="20"
        [mode]="'indeterminate'"
      ></mat-progress-spinner>
      <ng-template #dataVisible>
        <span
          class="bill-value text-blue-theme-color font-semibold !text-sm sm:!text-base"
          >{{ this.selectedDeliveryMethod?.estimateTime }}</span
        >
      </ng-template>
    </div>
  </ng-template>
</mat-drawer-container>
